/// <amd-module name="SuiteCommerce.StockNotifications.Item.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Item.Model", ["require", "exports", "Backbone", "SuiteCommerce.StockNotifications.Item.ImageHelper", "SuiteCommerce.StockNotifications.Item.Option.Collection"], function (require, exports, Backbone_1, Item_ImageHelper_1, Item_Option_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemModel = /** @class */ (function (_super) {
        __extends(ItemModel, _super);
        function ItemModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemModel.prototype, "value", {
            get: function () {
                return this.get('value');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemOptionsMatrix", {
            get: function () {
                return this.get('itemOptionsMatrix');
            },
            set: function (itemOptionMatrix) {
                this.set('itemOptionsMatrix', itemOptionMatrix);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "parentItem", {
            get: function () {
                return this.get('parentItem');
            },
            set: function (parentItem) {
                this.set('parentItem', parentItem);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixChildItems", {
            get: function () {
                return this.get('matrixChildItems') || this.get('matrixchilditems_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "isMatrixParent", {
            get: function () {
                return !!this.matrixChildItems;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "itemOptions", {
            get: function () {
                if (!this.isMatrixParent && this.parentItem) {
                    return this.parentItem.itemOptions;
                }
                if (this.get('itemOptions'))
                    return new Item_Option_Collection_1.ItemOptionCollection(this.get('itemOptions'));
                if (this.get('options'))
                    return new Item_Option_Collection_1.ItemOptionCollection(this.get('options'));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "matrixItemOptions", {
            get: function () {
                if (!this.itemOptionsMatrix) {
                    var itemOptions = this.itemOptions;
                    var filtered = [];
                    if (itemOptions) {
                        filtered = itemOptions.where({ isMatrixDimension: true });
                    }
                    this.itemOptionsMatrix = new Item_Option_Collection_1.ItemOptionCollection(filtered);
                }
                return this.itemOptionsMatrix;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "name", {
            get: function () {
                return this.get('storedisplayname2') || this.get('displayname') || this.get('itemid') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "description", {
            get: function () {
                var description = this.get('storedetaileddescription');
                var parentItem = this.parentItem;
                if (!description && parentItem && parentItem.internalId) {
                    return parentItem.description;
                }
                return description;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "price", {
            get: function () {
                var onlinePriceDetails = this.get('onlinecustomerprice_detail');
                var parentItem = this.parentItem;
                if (!onlinePriceDetails && parentItem && parentItem.internalId) {
                    return parentItem.price;
                }
                return {
                    number: onlinePriceDetails.onlinecustomerprice,
                    formatted: onlinePriceDetails.onlinecustomerprice_formatted,
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "images", {
            get: function () {
                return this.get('itemimages_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "thumbnail", {
            get: function () {
                var parentItem = this.parentItem;
                var itemImagesDetail = this.images || parentItem.images || {};
                if (itemImagesDetail.thumbnail || Item_ImageHelper_1.ItemImageHelper.findThumbnail(itemImagesDetail)) {
                    return Item_ImageHelper_1.ItemImageHelper.getThumbnailExisting(itemImagesDetail);
                }
                else {
                    return Item_ImageHelper_1.ItemImageHelper.getThumbnailFromAll(this, itemImagesDetail);
                }
            },
            enumerable: true,
            configurable: true
        });
        ItemModel.prototype.parse = function (data) {
            if (data.itemoptions_detail) {
                this.parseItemOptions(data);
            }
            if (data.matrixchilditems_detail) {
                this.parseMatrixChildItems(data);
            }
            return data;
        };
        ItemModel.prototype.parseItemOptions = function (dataArg) {
            if (dataArg.itemoptions_detail.fields) {
                dataArg.itemOptions = new Item_Option_Collection_1.ItemOptionCollection(dataArg.itemoptions_detail.fields);
            }
        };
        ItemModel.prototype.parseMatrixChildItems = function (data) {
            var _this = this;
            var ItemCollection = this.getCollectionClass();
            data.matrixChildItems = new ItemCollection(data.matrixchilditems_detail);
            data.matrixChildItems.each(function (childItem) {
                childItem.parentItem = _this;
            });
        };
        // Workaround to avoid circular dependencies with the collection
        ItemModel.prototype.getCollectionClass = function () {
            return require('SuiteCommerce.StockNotifications.Item.Collection').ItemCollection; // eslint-disable-line global-require
        };
        Object.defineProperty(ItemModel.prototype, "matrixChildForOptions", {
            get: function () {
                var matrixOptions = this.matrixItemOptions;
                var whereObject = {};
                var result = matrixOptions.every(function eachMatrixOption(matrixOption) {
                    var optionValue = matrixOption.value;
                    if (optionValue && (optionValue.label || optionValue.internalId)) {
                        whereObject[matrixOption.itemOptionId] = optionValue.label || optionValue.internalId;
                        return true;
                    }
                    return false;
                });
                if (result) {
                    return this.matrixChildItems.findWhere(whereObject);
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemModel.prototype, "optionsFormatted", {
            get: function () {
                var optionsFormatted = '';
                var parent = this.parentItem;
                if (!parent) {
                    return '';
                }
                var child = parent.matrixChildItems.findWhere({ internalid: this.internalId });
                this.get('itemOptions').forEach(function (option) {
                    if (option.get('ismatrixdimension')) {
                        var label = option.get('label');
                        var value = child.get(option.get('sourcefrom'));
                        if (optionsFormatted) {
                            optionsFormatted += " - " + label + " " + value;
                        }
                        else {
                            optionsFormatted += label + " " + value;
                        }
                    }
                });
                return optionsFormatted;
            },
            enumerable: true,
            configurable: true
        });
        return ItemModel;
    }(Backbone_1.Model));
    exports.ItemModel = ItemModel;
});
